import React from 'react';
import './statistics.css'
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { ChangeLanguage } from '../../redux/actions/LanguageAction'
import allStrings from "../../assets/strings";
import { connect } from 'react-redux';
import { BASE_END_POINT } from '../../urls'
import axios from 'axios'
import { setUser } from '../../redux/actions/AuthActions'
import Skeleton from 'react-loading-skeleton';
import moment from 'moment'
import { Spin, DatePicker, TreeSelect } from 'antd';
import 'moment/locale/ar';
import { Bar } from "react-chartjs-2";
import { withRouter, Redirect } from 'react-router-dom'
import StatisticCard from '../../component/statisticCard/statisticCard';
import { CSVLink } from "react-csv"
const { TreeNode } = TreeSelect;

let headers = [
  { label: "الموظف", key: "employee" },
  { label: " متوسط سرعة الرد", key: "avgRespondTime" },
];
let csvData = [];

class Statistics extends React.Component {

  state = {
    count: [],
    loading: false,
    averages: [],
    days: [],
    daysEN: [],
    daysAR: [],
    maxValue: 0,
    graphStep: 0,
    employees: [],
    startDate: null,
    endDate: null,
    projects: [],
    project: null,
    csvData: [],
    isReady: false,
  }

  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
      moment.locale('ar');
    } else {
      allStrings.setLanguage('en')
      moment.locale('en');
    }
  }

  componentDidMount() {
    this.fetchAllData()
  }

  onStartDateChange = (date) => {
    this.setState({
      startDate: date ? date.locale("en").format("YYYY-MM-DD") : null
    }, () => {
      this.fetchAllData();
    });
  }

  onEndDateChange = (date) => {
    this.setState({
      endDate: date ? date.locale("en").format("YYYY-MM-DD") : null
    }, () => {
      this.fetchAllData();
    });
  }

  fetchAllData = () => {
    this.getInterestsStatistics(this.state.project);
    this.getAvgRespondTimePerEmployee();
    this.dailyAvgRespondTimeGraph();
    this.getProjects()
  }
  getProjects = () => {
    axios.get(`${BASE_END_POINT}projects/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ projects: response.data.data })
      })
      .catch(error => {
        console.log("ALL projects ERROR")
        console.log(error.response)
      })
  }

  dailyAvgRespondTimeGraph = () => {
    const { startDate, endDate } = this.state;
    axios.get(`${BASE_END_POINT}admin/dailyAvgRespondTimeGraph`, {
      headers: {
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
      params: { startDate, endDate }
    })
      .then(response => {
        let daysEN = []
        let daysAR = []
        response.data.days.forEach(day => {
          daysAR.push(moment(day).locale('ar').format("ll"))
          daysEN.push(moment(day).locale('en').format('MMM Do YY'))
        });
        let arr = response.data.averages
        let max = Math.max(...arr) + 1;

        this.setState({
          loading: false,
          averages: response.data.averages,
          daysEN: daysEN,
          daysAR: daysAR,
          maxValue: max,
          graphStep: Math.floor(max / 10)
        })
      })
      .catch(error => {
        console.log("ALL graph ERROR", error.response)
      })
  }

  getInterestsStatistics = (project) => {
    const { startDate, endDate } = this.state;
    if (project == "ALL") {
      project = null
      this.setState({ project: project })
    }
    axios.get(`${BASE_END_POINT}admin/getInterestsStatistics`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`
      },
      params: { startDate, endDate, project }
    })
      .then(response => {
        this.setState({ count: response.data, loading: false })
      })
      .catch(error => {
        console.log("ALL count ERROR", error.response)
      })
  }

  getAvgRespondTimePerEmployee = () => {
    const { startDate, endDate } = this.state;
    axios.get(`${BASE_END_POINT}admin/getAvgRespondTimePerEmployee`, {
      headers: {
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
      params: { startDate, endDate }
    })
      .then(response => {
        this.setState({ employees: response.data.data })
        csvData = response.data.data.map(item => {
          return {
            ...{ employee: item.employee.fullname },
            ...{ avgRespondTime: item.avgRespondTime },
          };
        });
        this.setState({ csvData: csvData, isReady: true })
      })
      .catch(error => {
        console.log("ALL employees ERROR", error.response)
      })
  }

  render() {
    if (!this.props.currentUser.user.type === "ADMIN") return <Redirect to='/Home' />

    const { loading } = this.state;

    const data = {
      labels: this.props.isRTL ? this.state.daysAR : this.state.daysEN,
      datasets: [
        {
          label: "سرعه الرد بالساعه ",
          data: this.state.averages,
          fill: true,
          backgroundColor: "rgba(75, 192, 192, 0.6)",
          borderColor: "rgba(75, 192, 192, 1)",
          borderWidth: 1,
          barPercentage: 0.5,
          categoryPercentage: 0.6,
        },
      ],
    };

    const options = {
      responsive: true,
      plugins: {
        legend: {
          display: true,
          position: 'bottom',
          align: this.props.isRTL ? 'end' : 'start',
          labels: {
            fontColor: '#000',
            borderRadius: '4px',
            boxWidth: 20,
            padding: 20,
          }
        }
      },
      scales: {
        yAxes: [
          {
            position: 'left',
            ticks: {
              max: this.state.maxValue,
              min: 0,
              stepSize: this.state.graphStep
            }
          }
        ],
      },
    };
    return (
      <div className="statistics">
        <Spin spinning={this.state.loading} tip={allStrings.loading} size="large" style={{ color: '#1D9598' }}>
          <MDBContainer>
            <MDBRow>
              <div style={{
                textAlign: this.props.isRTL ? 'right' : 'left',
                flexDirection: this.props.isRTL ? 'row' : 'row-reverse',
                display: this.props.isRTL ? '' : 'flex',
                width: this.props.isRTL ? '100%' : '', padding: '5px 20px 25px'
              }}>
                <span style={{
                  display: 'inline-block',
                  color: '#43425D',
                  fontSize: '22px'
                }}>{allStrings.onThisMonth}</span>
                <span style={{
                  fontWeight: 'bold', fontSize: '22px', display: 'inline-block',
                  color: '#43425D', margin: '6px', lineHeight: this.props.isRTL ? 'auto' : '15px'
                }}>|</span>
                <span style={{
                  fontWeight: 'bold', fontSize: '22px', display: 'inline-block',
                  color: '#43425D'
                }}>{allStrings.statistic}</span>
              </div>

            </MDBRow>
            <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
              <MDBCol md="4" sm="4">
                <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{this.props.isRTL ? "من تاريخ" : "From Date"}</label>
                <DatePicker
                  onChange={this.onStartDateChange}
                  style={{ width: '100%' }}
                  format="YYYY-MM-DD"
                  placeholder={this.props.isRTL ? 'من تاريخ' : 'Start Date'}
                />
              </MDBCol>
              <MDBCol md="4" sm="4">
                <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{this.props.isRTL ? "إلى تاريخ" : "To Date"}</label>
                <DatePicker
                  onChange={this.onEndDateChange}
                  style={{ width: '100%' }}
                  format="YYYY-MM-DD"
                  placeholder={this.props.isRTL ? 'إلى تاريخ' : 'End Date'}
                />
              </MDBCol>
              <MDBCol md="4" sm="4">
                <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.project}</label>
                <TreeSelect virtual={false}
                  showSearch={true}
                  style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                  treeCheckable={false}
                  treeNodeFilterProp="title"
                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                  placeholder={allStrings.project}
                  onChange={(value) => {
                    console.log(value)
                    this.setState({ project: value });
                    this.getInterestsStatistics(value);
                  }}
                >
                  <TreeNode value="ALL" title={allStrings.all} key="ALL" />
                  {this.state.projects.map(val => (
                    <TreeNode value={val.id} title={this.props.isRTL ? val.name_ar : val.name_en} key={val.id} />
                  ))}
                </TreeSelect>
              </MDBCol>
            </MDBRow>
            <br></br>
            <br></br>
            <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
              <StatisticCard
                name={allStrings.avgRespondTime}
                value={this.state.count.avgRespondTime}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.activeInterests}
                value={this.state.count.activeInterests}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.interests}
                value={this.state.count.interestsCount}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.snapchatLeads}
                value={this.state.count.snapchatLeads}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.visitingsFromSnapchatLeads}
                value={this.state.count.visitingsFromSnapchatLeads}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.requestsFromSnapchatLeads}
                value={this.state.count.requestsFromSnapchatLeads}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.facebookLeads}
                value={this.state.count.facebookLeads}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.visitingsFromFacebookLeads}
                value={this.state.count.visitingsFromFacebookLeads}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.requestsFromFacebookLeads}
                value={this.state.count.requestsFromFacebookLeads}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.instagramLeads}
                value={this.state.count.instagramLeads}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.visitingsFromInstagramLeads}
                value={this.state.count.visitingsFromInstagramLeads}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.requestsFromInstagramLeads}
                value={this.state.count.requestsFromInstagramLeads}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.tiktokLeads}
                value={this.state.count.tiktokLeads}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.visitingsFromTiktokLeads}
                value={this.state.count.visitingsFromTiktokLeads}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.requestsFromTiktokLeads}
                value={this.state.count.requestsFromTiktokLeads}
                isRTL={this.props.isRTL}
                loading={loading}
              />
            </MDBRow>
            <br></br>
            <MDBRow>
              <MDBCol md="12">
                <p style={{
                  fontFamily: 'Cairo', background: ' #fff', marginBottom: '0px', padding: '18px 22px',
                  fontWeight: '600', color: '#43425D', fontSize: '17px', textAlign: this.props.isRTL ? 'right' : 'left'
                }}>{allStrings.statistic}</p>
                <div className="homeChart">
                  <Bar data={data} options={options} />
                </div>
              </MDBCol>
            </MDBRow>
            <br></br>
            <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
              <MDBCol xl="12" lg="12" md="12" sm="12">
                <div className="theCard" style={{ minHeight: '50px' }}>
                  <p className="topCard" style={{ color: '#43425D', textAlign: this.props.isRTL ? 'right' : 'left' }}>{allStrings.employees}</p>
                  <br></br>
                  <CSVLink
                    data={this.state.csvData}
                    headers={headers}
                    filename={"reports.csv"}
                    style={{ padding: '20px 0px', position: 'absolute', top: '0px' }}
                  >
                    <img alt="" src={require('../../assets/images/export-csv.png')} width="28"></img>
                  </CSVLink>
                  <table className="table table-borderless">
                    <thead className="thead-light">
                      <tr >
                        <th scope="col">{allStrings.avgRespondTime}</th>
                        <th scope="col">{allStrings.employee}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.loading ?
                        <div style={{ width: "100%" }} >
                          <Skeleton height={40} />
                          <Skeleton height={40} />
                          <Skeleton height={40} />
                          <Skeleton height={40} />
                          <Skeleton height={40} />
                          <Skeleton height={40} />
                        </div>
                        :
                        this.state.employees.length > 0 ?
                          this.state.employees.map(val => (
                            <tr onClick={() => this.props.history.push("/userInfo", { data: val.employee })}>
                              <td style={{ direction: 'rtl' }}>{val.avgRespondTime}</td>
                              <td>{val.employee.fullname}</td>
                            </tr>
                          ))
                          :
                          <tr style={{ height: '300px' }}>
                            <th colSpan="8" className="noData" style={{ background: "#fff" }}>
                              <p style={{ marginTop: '10rem', textAlign: 'center', }}>{allStrings.noData}</p>
                            </th>
                          </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </Spin>
      </div>
    )
  }
}
const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})
const mapDispatchToProps = {
  setUser,
  ChangeLanguage
}
export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(Statistics)
);